import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { headerHeight } from "../../NavBars/Header/hardCodeData";
import tradeInImage from "../../Images/TradeId/byd_trade-in.png";

const TradeIn = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: `calc(100vh - ${headerHeight})`,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Hero Section with Background Image */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          mt: headerHeight,
        }}
      >
        <Box
          sx={{
            height: `calc(100vh - ${headerHeight})`,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage: {
              xs: `url(${tradeInImage})`,
              md: `url(${tradeInImage})`,
            },
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.4)",
              zIndex: 1,
            },
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              position: "relative",
              zIndex: 2,
              textAlign: "center",
              px: { xs: 2, md: 4 },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "5vw", md: "48px", lg: "56px" },
                color: "#fff",
                fontWeight: 700,
                letterSpacing: "-2px",
                textTransform: "uppercase",
                mb: { xs: 3, md: 4 },
                lineHeight: 1.2,
              }}
            >
              {t("trade_in:title")}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Montserrat",
                fontSize: { xs: "4vw", md: "20px", lg: "24px" },
                color: "#fff",
                fontWeight: 400,
                maxWidth: { xs: "90%", md: "800px" },
                mx: "auto",
                lineHeight: 1.5,
                textAlign: "center",
              }}
            >
              {t("trade_in:description")}
            </Typography>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default TradeIn;
